// extracted by mini-css-extract-plugin
export default {"LayoutErrorPortlet":"index__LayoutErrorPortlet__Z9KYO","symbol":"index__symbol__poYKb","code":"index__code__PuFIj","text":"index__text__GlxdM"};